import { createFileRoute } from "@tanstack/react-router"
import { OutlookConfiguration } from "modules/settings/components/integrations/outlook"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/outlook")({
  component: OutlookConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.outlook.title"),
    })
  },
})
